"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedAmount = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var FormattedAmount_styled_1 = require("./FormattedAmount.styled");
var FormattedAmount = function (_a) {
    var amount = _a.amount;
    var Strong = (0, core_1.useComponents)().Strong;
    var _b = __read(amount.split('.'), 2), pounds = _b[0], pence = _b[1];
    return pence == null ? (react_1.default.createElement(FormattedAmount_styled_1.StyledFormattedAmount, { fontSize: 4, as: Strong }, pounds)) : (react_1.default.createElement(FormattedAmount_styled_1.StyledFormattedAmount, { fontSize: 4, as: Strong }, "".concat(pounds, "."),
        react_1.default.createElement(FormattedAmount_styled_1.StyledFormattedAmountPence, null, pence)));
};
exports.FormattedAmount = FormattedAmount;
